import React from 'react';

export const Success = ({ width = '14', height = '14', color = 'white' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.40002C6.69839 2.40002 2.39999 6.69842 2.39999 12C2.39999 17.3016 6.69839 21.6 12 21.6C17.3016 21.6 21.6 17.3016 21.6 12C21.6 6.69842 17.3016 2.40002 12 2.40002ZM10.8003 16.8007C10.4835 16.8007 10.1775 16.6759 9.95189 16.4491L7.55189 14.0491C7.08269 13.5799 7.08269 12.8215 7.55189 12.3523C8.02109 11.8831 8.77949 11.8831 9.24869 12.3523L10.6143 13.7179L14.6019 7.73471C14.9691 7.18271 15.7131 7.03391 16.2663 7.40231C16.8171 7.77071 16.9659 8.51471 16.5987 9.06671L11.7987 16.2667C11.5995 16.5655 11.2755 16.7599 10.9191 16.7947C10.8783 16.7983 10.8399 16.8007 10.8003 16.8007Z"
        fill={color}
      />
    </svg>
  );
};
